<template>
  <card-deck title="STITCHER">
    <div id="stitcher_leader_line_end" class="data-source-stitcher flex flex-column">
      <div id="stitcher_leader_line_start" class="data-source_leader-base right output"></div>
      <b-alert
        :show="dismissCountDown"
        dismissible
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged" style="background-color: #CE25DD; color: white" >{{saveMessage}}</b-alert>
      <div class="pad-x--xl mar-bottom--md">
        <lottie-animation
          animation-id="test_animation"
          :options="aniData"
          :speed="1.2"
          :width="200" />
      </div>
      <hr class="separator" />
      <span class="heading text--center mar-y--sm">Schedule</span>
      <hr class="separator" />
      <label class="toggle mx-auto mar-top--lg">
        <input class="toggle_input" type="checkbox" aria-labeledby="schedule_label" @change="toggleChange" v-model='scheduleOn'>
        <span class="toggle_switch">
          <span class="toggle_switch-label toggle_switch-label--left">On</span>
          <span class="toggle_switch-label toggle_switch-label--right">Off</span>
        </span>
      </label>
      <button class="ghost-button font-weight--700 mx-auto mar-top--md" @click="showModalSchedule = true">Manage Schedule</button>
      <p class="mt-2 mb-1">Last Run: {{lastDate | formatDate}}</p>
      <p class="mb-2">Next Run: Daily at {{nextRun}}</p>
      <button class="ghost-button font-weight--700 mx-auto" @click="stitch">Run Now</button>
    </div>
      <div v-for="(rule, ruleIndex) in ruleData" :key='ruleIndex'>
        <div v-if="contentDataCRM[0].type === 'salesforce'">
          <StitchRuleSF
          class="mar-bottom--md"
          :crmInfo='contentDataCRM'
          :allRules='rule'
          :ruleIndex = 'ruleIndex'
          @cancel='cancel(ruleIndex)'
          @save='saveRule'
          @delete="deleteConfirm(ruleIndex, rule.name)"></StitchRuleSF>
        </div>
        <div v-else>
          <StitchRuleMD
          class="mar-bottom--md"
          :crmInfo='contentDataCRM'
          :allRules='rule'
          :ruleIndex = 'ruleIndex'
          @cancel='cancel(ruleIndex)'
          @save='saveRule'
          @delete="deleteConfirm(ruleIndex, rule.name)"></StitchRuleMD>
        </div>
      </div>
      <DataEngineAddStitch
        @simple='getSimple'
        @raw='getRaw'
        :crmType='crm_type'
        ></DataEngineAddStitch>
      <div>
        <ModalSchedule
          v-if="showModalSchedule"
          :schedule='schedule'
          :errorSaveMessage='errorSchedule'
          @cancel="cancelSchedule"
          @close='showModalSchedule= false'
          @save="saveSchedule"></ModalSchedule>
        <ModalConfirm
          v-if="showModalConfirm"
          :message="'Are you sure you want to delete '+ ruleName + ' it can not be undone.'"
          @confirm="deleteRule()"
          @cancel="showModalConfirm = false"></ModalConfirm>
      </div>
  </card-deck>
</template>
<script>
import { mapState } from 'vuex'
import CardDeck from '@/components/CardDeck.vue'
import LottieAnimation from '@/components/LottieAnimation.vue'
import * as stitchAnimation from '@/assets/lottie/stitch.json'
import DataEngineAddStitch from '@/components/DataEngineAddStitch.vue'
import StitchRuleSF from '@/components/StitchRuleSF'
import StitchRuleMD from '@/components/StitchRuleMD'
import ModalSchedule from '@/components/ModalSchedule.vue'
import ModalConfirm from '@/components/ModalConfirm.vue'
import moment from 'moment'
import rulesApi from '@/api/Stitcher/rules.js'
import Schedule from '@/api/Stitcher/schedule.js'

export default {
  components: {
    CardDeck,
    LottieAnimation,
    DataEngineAddStitch,
    StitchRuleSF,
    StitchRuleMD,
    ModalSchedule,
    ModalConfirm
  },

  props: {},

  data () {
    return {
      aniData: {
        animationData: stitchAnimation.default,
        autoplay: false,
        loop: false
      },
      widgetIsOpen: false,
      showModalSchedule: false,
      showModalConfirm: false,
      select_value1: 'and',
      AnalyticsName: '',
      option1: [{ 'name': 'All', 'value': 'and' }, { 'name': 'Any', 'value': 'or' }],
      select_value2: '',
      CRMData: [],
      deleteIndex: '',
      ruleName: '',
      saveMessage: '',
      dismissSecs: 8,
      dismissCountDown: 0,
      scheduleOn: false,
      lastDate: '',
      nextRun: '',
      scheduleMessage: '',
      schedule: {
        hour: '',
        minute: '',
        email_error: [],
        email_success: [],
        status: '',
        period: ''
      },
      crm_type: ''
    }
  },
  computed: {
    ruleData () {
      return this.$store.state.api.rules
    },
    errorSchedule () {
      return this.scheduleMessage
    },
    ...mapState(
      'data', {
        contentDataCRM: state => state.CRMData
      })
  },
  methods: {
    stitch () {
      Schedule.runSchedule()
      if (!this.scheduleOn) {
        this.$store.commit('lottiePlay', {
          animationID: 'test_animation'
        })

        setTimeout(() => {
          this.$store.commit('lottiePlay', {
            animationID: 'test_animation',
            reverse: true
          })
        }, 1200)
      } else {
        this.$store.commit('lottiePlay', {
          animationID: 'test_animation',
          reverse: true
        })

        setTimeout(() => {
          this.$store.commit('lottiePlay', {
            animationID: 'test_animation'
          })
        }, 1300)
      }
    },
    toggleChange () {
      if (this.scheduleOn) {
        this.$store.commit('lottiePlay', {
          animationID: 'test_animation'
        })
      } else {
        this.$store.commit('lottiePlay', {
          animationID: 'test_animation',
          reverse: true
        })
      }
      this.saveSchedule()
    },
    contentData () {
      rulesApi.getRules()
    },
    getSimple () {
      var rule = { 'name': 'Name',
        'crm_connection_id': null,
        'crm_object': '',
        'and_or': 'and',
        'rule_type': 'SIMPLE',
        'conditions': [
          {
            'field': '',
            'operator': '',
            'value': ''
          }
        ],
        'new': true }
      this.$store.commit('addRule', rule)
    },
    getRaw () {
      var rule = {
        'name': 'Name',
        'crm_connection_id': null,
        'soql': '',
        'rule_type': 'SOQL',
        'new': true
      }
      this.$store.commit('addRule', rule)
    },
    saveRule (message) {
      this.saveMessage = message
      this.dismissCountDown = this.dismissSecs
      this.contentData()
    },
    cancel (index) {
      this.$store.commit('cancelRule', index)
    },
    deleteConfirm (index, name) {
      this.showModalConfirm = true
      this.deleteIndex = index
      this.ruleName = name
    },
    deleteRule () {
      var type = this.ruleData[this.deleteIndex].rule_type
      this.showModalConfirm = false
      rulesApi.postRuleDelete({
        'rule_id': this.ruleData[this.deleteIndex].rule_id,
        'rule_type': type.toLowerCase()
      })
        .then(response => {
          return response
        })
      this.$store.commit('removeRule', this.deleteIndex)
      this.$store.dispatch('ux/turnOffSpotlight')
    },
    CrmInfo () {
      // TODO: test this to see if we need it
      this.contentDataCRM.forEach(data => {
        data.name = data.company_name
        data.value = data.crm_connection_id.toString()
      })
      this.CRMData = this.contentDataCRM
    },
    saveSchedule () {
      this.schedule.hour = parseInt(this.schedule.hour)
      this.setTime24Hour()
      this.message = ''
      if (this.scheduleOn) {
        this.schedule.status = 'enabled'
      } else {
        this.schedule.status = 'disabled'
      }
      Schedule.saveSchedule(this.schedule)
        .then(response => {
          if (!response.error) {
            this.scheduleMessage = ''
            this.showModalSchedule = false
            this.saveMessage = response.status
            this.dismissCountDown = this.dismissSecs
            this.nextRun = moment({ hour: this.schedule.hour, minute: this.schedule.minute }).format('hh:mm a')
          } else {
            this.scheduleMessage = response.error
          }
        })
      setTimeout(() => {
        this.setTime12Hour()
      }, 50)
    },
    getSchedule () {
      Schedule.getSchedule()
        .then(response => {
          this.schedule = response
          this.lastDate = this.schedule.last_modified_date
          this.nextRun = moment({ hour: response.hour, minute: response.minute }).format('hh:mm a')
          this.setTime12Hour()

          if (this.schedule.status === 'enabled') {
            this.scheduleOn = true
          }
        })
    },
    cancelSchedule () {
      this.showModalSchedule = false
      this.getSchedule()
    },
    setTime12Hour () {
      if (this.schedule.hour >= 13) {
        this.schedule.hour = this.schedule.hour - 12
        this.schedule.period = 'PM'
      } else if (this.schedule.hour === 12) {
        this.schedule.period = 'PM'
      } else if (this.schedule.hour === 0) {
        this.schedule.hour = 12
        this.schedule.period = 'AM'
      } else {
        this.schedule.period = 'AM'
      }
    },
    setTime24Hour () {
      if (this.schedule.period === 'PM' && this.schedule.hour !== 12) {
        this.schedule.hour = this.schedule.hour + 12
        if (this.schedule.hour >= 24) {
          this.schedule.hour = 0
        }
      }
      if (this.schedule.period === 'AM' && this.schedule.hour === 12) {
        this.schedule.hour = 0
      }
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      this.$store.commit('updateLeaderLines')
    }
  },
  created () {
    this.getSchedule()
    setTimeout(() => {
      this.crm_type = this.$store.state.data.CRMData[0].type
    }, 400)
  },
  mounted () {
    this.contentData()
    this.CrmInfo()
  },
  beforeDestroy () {
  },

  updated () {
  }
}
</script>
